import { render, staticRenderFns } from "./InsightsFiltros.vue?vue&type=template&id=023bd1fb&scoped=true"
import script from "./InsightsFiltros.vue?vue&type=script&lang=js"
export * from "./InsightsFiltros.vue?vue&type=script&lang=js"
import style0 from "./InsightsFiltros.vue?vue&type=style&index=0&id=023bd1fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023bd1fb",
  null
  
)

export default component.exports